<template>
  <div>
    <div v-if="!loading">
      <page-header>
        <template #title>
          <h1 class="page-title">Defleet Vehicle</h1>
        </template>
      </page-header>

      <div class="card mb-4">
        <div class="card-body">
          <fieldset>
            <legend>Vehicle Details</legend>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <div class="col-md-4">
                    <label class="control-label">
                      Vehicle:
                    </label>
                  </div>
                  <div class="col-md-8">
                    {{ vehicle?.registration }}
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="col-md-4">
                    <label class="control-label ">
                      Make:
                    </label>
                  </div>
                  <div class="col-md-8">
                    {{ vehicle?.make?.label }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <div class="col-md-4">
                    <label class="control-label ">
                      VIN:
                    </label>
                  </div>
                  <div class="col-md-8">
                    {{ vehicle?.vin }}
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="col-md-4">
                    <label class="control-label ">
                      Model:
                    </label>
                  </div>
                  <div class="col-md-8">
                    {{ vehicle?.model }}
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body">
          <fieldset>
            <legend>Details</legend>
            <div class="row">
              <div class="col-md-6">
                <selectlist
                  :options="defleetReasons"
                  v-model="form.defleet_reason_id"
                  name="defleet_reason"
                  placeholder="Please Select"
                  helper="Please select the Defleet reason"
                  label="Defleet Reason"
                ></selectlist>

                <selectlist
                  :options="totalLossCategory"
                  v-model="form.total_loss_category"
                  name="total_loss_category"
                  placeholder="Please Select"
                  helper="Please select the total loss category"
                  label="Total Loss Category"
                ></selectlist>
                <!--                <input-block-->
                <!--                    v-model="form.reason"-->
                <!--                    name="reason"-->
                <!--                    label="Reason"-->
                <!--                    helper="Please enter reason"-->
                <!--                ></input-block>-->
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="col-md-4">
                    <label for="" class="control-label">
                      Removed from Dart/Congestion
                    </label>
                  </div>
                  <div class="col-md-8">
                    <toggleswitch
                      :labels="true"
                      name="removed_from_dart_congestion"
                      v-model="form.removed_from_dart_congestion"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-md-4">
                    <label for="" class="control-label">
                      Removed from MID
                    </label>
                  </div>
                  <div class="col-md-8">
                    <toggleswitch
                      :labels="true"
                      name="removed_from_mid"
                      v-model="form.removed_from_mid"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-md-4">
                    <label for="" class="control-label">
                      V5
                    </label>
                  </div>
                  <div class="col-md-8">
                    <toggleswitch
                      :labels="true"
                      name="v5"
                      v-model="form.v5"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-md-4">
                    <label for="" class="control-label">
                      Spare Key
                    </label>
                  </div>
                  <div class="col-md-8">
                    <toggleswitch
                      :labels="true"
                      name="spare_key"
                      v-model="form.spare_key"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-md-4">
                    <label for="" class="control-label">
                      SORN
                    </label>
                  </div>
                  <div class="col-md-8">
                    <toggleswitch
                      :labels="true"
                      name="sorn"
                      v-model="form.sorn"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group" v-if="!!isTheft()">
                  <div class="col-md-4">
                    <label for="" class="control-label">
                      Unrecovered stolen?
                    </label>
                  </div>
                  <div class="col-md-8">
                    <toggleswitch
                      :labels="true"
                      name="un_recovered_stolen"
                      v-model="form.un_recovered_stolen"
                    ></toggleswitch>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <div class="row">
            <div class="col-md-6">
              <fieldset>
                <legend>Dates</legend>
                <datepicker-input
                  v-if="!!form.removed_from_dart_congestion"
                  name="removed_from_dart_congestion_at"
                  label="Removed From Dart/Congestion Date"
                  helper="Please enter the date the vehicle removed from Dart/Congestion"
                  v-model="form.removed_from_dart_congestion_at"
                ></datepicker-input>

                <datepicker-input
                  v-if="!!form.sorn"
                  name="sorn_at"
                  label="SORN Date"
                  helper="Please enter the SORN date"
                  v-model="form.sorn_at"
                ></datepicker-input>

                <!--                <datepicker-input-->
                <!--                  name="collection_date"-->
                <!--                  label="Collection Date"-->
                <!--                  helper="Please enter the collection date"-->
                <!--                  v-model="form.collection_date"-->
                <!--                ></datepicker-input>-->

                <datepicker-input
                  v-if="form.removed_from_mid"
                  name="off_mid_date"
                  label="Off MID date"
                  helper="Please enter the off MID date"
                  v-model="form.off_mid_date"
                ></datepicker-input>
              </fieldset>
            </div>
            <div class="col-md-6" v-if="!isTheft()">
              <fieldset>
                <legend>Disposal Info</legend>
                <!--                <inputbox-->
                <!--                  v-model="form.customer"-->
                <!--                  name="customer"-->
                <!--                  label="Customer"-->
                <!--                  helper="Please enter customer name"-->
                <!--                ></inputbox>-->
                <company-select
                  id="company-select"
                  :types="companyTypes"
                  :company="getCompany"
                  ref="company"
                ></company-select>

                <currency-input
                  label="Residual Value"
                  name="residual_value"
                  helper="Please enter the residual value"
                  v-model="form.residual_value"
                >
                  <div slot="leftAddon">&pound;</div>
                </currency-input>

                <currency-input
                  label="Net Book Value"
                  name="net_book_value"
                  helper="Please enter the net book value"
                  v-model="form.net_book_value"
                >
                  <div slot="leftAddon">&pound;</div>
                </currency-input>

                <currency-input
                  label="Sale Price"
                  name="sale_price"
                  helper="Please enter the sale price"
                  v-model="form.sale_price"
                >
                  <div slot="leftAddon">&pound;</div>
                </currency-input>

                <datepicker-input
                  name="sale_date"
                  label="Sale Date"
                  helper="Please enter the sale date"
                  v-model="form.sale_date"
                ></datepicker-input>

                <datepicker-input
                  name="payment_date"
                  label="Payment Date"
                  helper="Please enter the payment date"
                  v-model="form.payment_date"
                ></datepicker-input>

                <inputbox
                  v-model="form.invoice_number"
                  name="invoice_number"
                  label="Invoice Number"
                  helper="Please enter invoice number"
                ></inputbox>

                <datepicker-input
                  name="collected_at"
                  label="Collected Date"
                  helper="Please enter the collected date"
                  v-model="form.collected_at"
                ></datepicker-input>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <button
            class="btn btn-primary btn-raised"
            name="save"
            v-on:click.prevent="submit"
          >
            <i class="icon icon-save"></i> Save
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <preloader></preloader>
    </div>
  </div>
</template>

<script>
import Company from './../Shared/Company';
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';
import PageHeader from './../Shared/PageHeader.vue';

export default {
  props: {
    identifier: {
      type: String
    }
  },

  components: {
    CurrencyInput,
    'company-select': Company,
    PageHeader
  },

  data() {
    return {
      currentView: 'details',
      vehicle: null,
      disabled: {
        from: new Date()
      },
      form: new window.Form({
        reference_number: null,
        registration: null,
        make_id: null,
        model: null,
        vin: null,
        defleet_reason_id: null,
        total_loss_category: null,
        reason: null,
        removed_from_dart_congestion: null,
        removed_from_mid: null,
        v5: null,
        spare_key: null,
        sorn: null,
        un_recovered_stolen: null,
        removed_from_dart_congestion_at: null,
        sorn_at: null,
        defleet_arranged_at: null,
        collection_date: null,
        off_mid_date: null,
        customer_id: null,
        customer_name: null,
        customer_email_address: null,
        customer_telephone_number: null,
        customer_address_line_one: null,
        customer_address_line_two: null,
        customer_city: null,
        customer_postcode: null,
        residual_value: null,
        net_book_value: null,
        sale_price: null,
        sale_date: null,
        payment_date: null,
        invoice_number: null,
        v5_processed: null,
        collected_at: null
      }),
      data_entered: false,
      indicator: false,
      companyTypes: []
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },

    loading() {
      return this.identifier && !this.vehicle;
    },

    defleetReasons() {
      return this.$store.getters['DefleetReasons/all'] || [];
    },
    totalLossCategory() {
      return [
        { id: 'B', label: 'B' },
        { id: 'N', label: 'N' }
      ];
    },
    getCompany() {
      return {
        company_id: this.form.customer_id,
        name: this.form.customer_name,
        email_address: this.form.customer_email_address,
        telephone_number: this.form.customer_telephone_number,
        address_line_one: this.form.customer_address_line_one,
        address_line_two: this.form.customer_address_line_two,
        city: this.form.customer_city,
        postcode: this.form.customer_postcode
      };
    }
  },

  mounted() {
    this.$store.commit('DefleetReasons/retrieve');

    if (this.identifier) {
      this.loadVehicle();
    }
  },

  methods: {
    setRegistration(registration) {
      this.form.registration = registration;
    },

    setVehicle(vehicle) {
      this.vehicle = vehicle;

      this.form.reference_number = vehicle.reference_number;
      this.form.registration = vehicle.registration;
      this.form.make_id = vehicle.make_id;
      this.form.model = vehicle.model;
      this.form.vin = vehicle.vin;
      this.form.defleet_reason_id = vehicle.defleet_reason_id;
      this.form.total_loss_category = vehicle.total_loss_category;
      this.form.reason = vehicle.reason;
      this.form.removed_from_dart_congestion =
        vehicle.removed_from_dart_congestion;
      this.form.removed_from_mid = vehicle.removed_from_mid;
      this.form.v5 = vehicle.v5;
      this.form.spare_key = vehicle.spare_key;
      this.form.sorn = vehicle.sorn;
      this.form.un_recovered_stolen = vehicle.un_recovered_stolen;
      this.form.removed_from_dart_congestion_at =
        vehicle.removed_from_dart_congestion_at || new Date();
      this.form.sorn_at = vehicle.sorn_at || new Date();
      this.form.defleet_arranged_at = vehicle.defleet_arranged_at;
      this.form.collection_date = vehicle.collection_date;
      this.form.off_mid_date = vehicle.off_mid_date || new Date();
      this.form.customer_id = vehicle.customer_id;
      this.form.customer_name = vehicle.customer_name;
      this.form.customer_email_address = vehicle.customer_email_address;
      this.form.customer_telephone_number = vehicle.customer_telephone_number;
      this.form.customer_address_line_one = vehicle.customer_address_line_one;
      this.form.customer_address_line_two = vehicle.customer_address_line_two;
      this.form.customer_city = vehicle.customer_city;
      this.form.customer_postcode = vehicle.customer_postcode;
      this.form.residual_value = vehicle.residual_value;
      this.form.net_book_value = vehicle.net_book_value;
      this.form.sale_price = vehicle.sale_price;
      this.form.sale_date = vehicle.sale_date;
      this.form.payment_date = vehicle.payment_date;
      this.form.invoice_number = vehicle.invoice_number;
      this.form.v5_processed = vehicle.v5_processed;
      this.form.collected_at = vehicle.collected_at;
    },

    isTheft() {
      let reason = this.defleetReasons?.find(
        reasons => reasons.id === this.form.defleet_reason_id
      );

      return reason?.name === 'stolen';
    },

    submit() {
      window.toastify.info('Saving', "We're saving the vehicle...");
      if (this.$refs.company?.form) {
        this.setCompany(this.$refs.company.form);
      }

      let identifier = this.$store.getters.user.tenant.identifier;
      this.form
        .put(`/fleet/${identifier}/${this.identifier}/defleet`)
        .then(response => {
          window.toastify.success('Saved', "We've updated the vehicle!");
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the vehicle.'
          );
        });
    },

    loadVehicle() {
      if (this.identifier && !this.vehicle && this.user?.tenant?.identifier) {
        window.Ajax.get(
          `/fleet/${this.user?.tenant?.identifier}/${this.identifier}`
        )
          .then(({ data }) => {
            this.setVehicle(data);
          })
          .catch(error => {
            window.toastify.error(
              'Oops',
              'An error occurred while loading the vehicle'
            );
          });
      }
    },

    sendToDefleetView() {
      this.indicator = true;

      this.sendToRoute(this.identifier);
    },

    sendToRoute(identifier) {
      this.$router.push(`/defleet/${identifier}`);
    },

    setCompany(company) {
      this.form.customer_id = company.company_id;
      this.form.customer_name = company.name;
      this.form.customer_email_address = company.email_address;
      this.form.customer_telephone_number = company.telephone_number;
      this.form.customer_address_line_one = company.address_line_one;
      this.form.customer_address_line_two = company.address_line_two;
      this.form.customer_city = company.city;
      this.form.customer_postcode = company.postcode;
    }
  },

  watch: {
    user() {
      this.loadVehicle();
    }
  }
};
</script>
